import Carousel from '../base/Carousel';
import DiagnosisArticle from '../DiagnosisArticle';

/**
 * Инициализация карусели в диагностике
 * И превью статей в ней
 */
export default () => {
    const $carouselDiagnosisArticle = $('.carousel--diagnosis-articles');
    // console.log($carouselDiagnosisArticle);
    if ($carouselDiagnosisArticle.length === 0) {
        return;
    }

    const carouselDiagnosisArticles = new Carousel($carouselDiagnosisArticle);
    const diagnosisArticle = new DiagnosisArticle($carouselDiagnosisArticle.find('.diagnosis-article'));

    diagnosisArticle.init();

    carouselDiagnosisArticles.init(
        {
            spaceBetween: 20,
        },
        {
            slidesPerView: 3,
            loop: false,
            breakpoints: {
                767: {
                    slidesPerView: 'auto',
                },
            },
        }
    );
};
